import {FIELD_TYPE} from "types/enums";

const {INPUT, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Mã chi nhánh",
    name: "code",
  },
  {
    type: INPUT,
    label: "Tên chi nhánh",
    name: "name",
  },
  {
    type: INPUT,
    label: "Mô tả",
    name: "description",
  },
];

export {fields};
